// Device provisioning key. A unique key is baked into each Pi image (written
// once to a file at first boot) and handed to the app by the kiosk launcher via
// the URL, e.g. `https://player.stage.vizzly.net/?provisioning_key=<key>`.
//
// Because it lives in a plain file on the Pi (outside the browser sandbox), it
// survives a full browser-storage wipe — so on boot, if our token is gone, we
// can re-authenticate automatically instead of dropping to the pairing screen.
//
// The URL param is the durable source (present on every fresh launch); we also
// cache a copy in localStorage as an in-session fallback across reloads.

const STORAGE_KEY = 'vz_provisioning_key';
const URL_PARAM = 'provisioning_key';

export function getProvisionKey(): string {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(URL_PARAM);
    if (fromUrl) {
      try {
        localStorage.setItem(STORAGE_KEY, fromUrl);
      } catch {
        /* localStorage unavailable */
      }
      return fromUrl;
    }
    return localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}
